export { WarehouseCustomerService } from './WarehouseCustomerService';
